module.exports = __webpack_public_path__ + "staticcomp/img/content_2.5b93701.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/8/content_2.jpg
// module id = 33pO
// module chunks = 39